import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_ITEMS } from "../data/content";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#070C14]/80 backdrop-blur-2xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-8 lg:px-10">
        <Link to="/" data-testid="header-logo-link" className="group flex items-center gap-3" aria-label="CLACH home">
          <img src={COMPANY.mark} alt="CLACH Global Services logo" className="h-10 w-auto transition-transform duration-500 group-hover:scale-105" />
          <span className="hidden font-heading text-sm font-bold uppercase tracking-[0.28em] text-white md:block">Clach</span>
        </Link>

        <nav data-testid="desktop-navigation" className="hidden items-center gap-7 lg:flex" aria-label="Primary navigation">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-mono text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 ${isActive ? "text-amber-400" : "text-slate-300 hover:text-white"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="header-contact-cta"
          className="hidden items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-amber-300 transition-all duration-300 hover:border-amber-300 hover:bg-amber-400 hover:text-[#111827] lg:flex"
        >
          Start a brief <ArrowUpRight size={14} />
        </Link>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-label="Toggle navigation menu"
          className="rounded-full border border-white/15 p-3 text-white lg:hidden"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-navigation" className="border-t border-white/10 bg-[#070C14]/95 px-4 py-6 backdrop-blur-2xl lg:hidden">
          <div className="flex flex-col gap-2">
            {NAV_ITEMS.map((item, index) => (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `rounded-2xl px-4 py-4 font-heading text-2xl font-bold ${isActive ? "bg-blue-500/15 text-amber-300" : "text-white"}`
                }
              >
                <span className="mr-3 font-mono text-xs text-blue-400">0{index + 1}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
